/* eslint-disable import/prefer-default-export */

/*
* @category  Puma
* @author    Beshoy Samuel <info@scandiweb.com>
* @license   http://opensource.org/licenses/OSL-3.0 The Open Software License 3.0 (OSL-3.0)
* @copyright Copyright (c) 2023 Scandiweb, Inc (https://scandiweb.com)
*/

import {
    ONE_DAY_IN_SECONDS, TEMP_GUEST_ADDRESS_DATA, TEMP_GUEST_EMAIL
} from 'Route/Checkout/Checkout.config';
import BrowserDatabase from 'Util/BrowserDatabase/BrowserDatabase';

/** @namespace Scandipwa/Util/CheckoutAddressData/invalidateTempGuestData */
export const invalidateTempGuestData = () => {
    const tempAddressData = BrowserDatabase.getItem(TEMP_GUEST_ADDRESS_DATA);
    const tempEmailData = BrowserDatabase.getItem(TEMP_GUEST_EMAIL);

    if (tempAddressData && tempEmailData) {
        BrowserDatabase.setItem(
            { shipping_address: tempAddressData.shipping_address, valid: false },
            TEMP_GUEST_ADDRESS_DATA,
            ONE_DAY_IN_SECONDS
        );
        BrowserDatabase.setItem(
            { guest_email: tempEmailData.guest_email, valid: false },
            TEMP_GUEST_EMAIL,
            ONE_DAY_IN_SECONDS
        );
    }
};
